import { render, staticRenderFns } from "./recordmanage.vue?vue&type=template&id=089fe84b"
import script from "./recordmanage.vue?vue&type=script&lang=js"
export * from "./recordmanage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports